<template>
  <main class="page-operative page-operative-project page-operative-project-edit">
    <div class="container-fluid">
      <PageTitle>Modifica progetto</PageTitle>

      <div v-if="loading">LOADING ...</div>
      <div v-else-if="errorLoadingData">Progetto da modificare non trovato</div>
      <div v-else-if="company && !userCanEdit">Utente non abilitato</div>
      <FormProject v-else :project.sync="project" :personnel="personnel" :libraryCosts="libraryCosts" :libraryImputedCosts="libraryImputedCosts" edit @saved="saveProject" />
    </div>
  </main>
</template>

<script>

import operativePageMixin from '@/mixins/operativePage.js';

export default {
  mixins: [operativePageMixin],
  components: {
    PageTitle: () => import('@/views/components/Layout/LayoutOperative/PageTitle.vue'),
    FormProject: () => import('@/views/components/Operative/Form/FormProject.vue'),
  },
  data () {
    return {
      project: null,
      loading: true,
      errorLoadingData: false,
      personnel: [],
      libraryCosts: [],
      libraryImputedCosts: [],
    };
  },
  methods: {
    saveProject (project) {
      this.$api.updateProject(this.company.id, project.id, project)
        .then(() => {
          this.$router.push({
            name: 'operative-company.projects.list',
            query: {
              forecast: this.$route.query?.forecast || null,
            },
          });
        })
        .catch(this.$log.error)
      ;
    },
  },
  mounted () {
    this.loading = true;
  },
  watch: {
    company: {
      immediate: true,
      handler: function () {
        if (!this.company) {
          return;
        }

        this.$api.getCostiPersonale(this.company.id)
          .then(res => {
            this.personnel = res.data?.costi || [];
          })
          .catch(this.$log.error)
        ;

        this.$api.listProjectLibraryCosts(this.company.id)
          .then(res => {
            this.libraryCosts = res.data?.costs || [];
          })
          .catch(this.$log.error)
        ;

        this.$api.listImputedCosts(this.company.id)
          .then(res => {
            this.libraryImputedCosts = res.data?.costs || [];
          })
          .catch(this.$log.error)
        ;

        this.$api.getProject(this.company.id, this.$route.params.projectId)
          .then(res => {
            this.project = res.data;
          })
          .catch(err => {
            this.errorLoadingData = true;
            this.$log.error(err);
          })
          .finally(() => {
            this.loading = false;
          })
        ;
      },
    },
  },
};

</script>
